<div class="padding flex column">
	<b class="margin-bottom-small">Current Status</b>

	<div class="flex column">
		<div class="flex border padding flex-1">
			<h4 class="normal primary">{{ data.currentStatus?.name }}</h4>
		</div>
		<div class="padding flex column center margin-top-small">
			<i class="fa-solid fa-arrow-down fa-2xl primary"></i>
		</div>
		<span>Select new status:</span>
		<div class="margin-top-small flex column flex-1">
			<div class="flex column border">
				@for (status of datasource; track status) {
					<div
						class="hover padding-small {{ status.selected ? 'bg-primary white' : '' }} flex center between"
						(click)="selectStatus(status)"
						[class.disabled]="status.disabled">
						{{ status.name }}
					</div>
				}
			</div>
		</div>
	</div>

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button class="stroked margin-right-small" (click)="onClose()">
				<i class="fa-solid fa-rotate-left margin-right-small"></i>
				Discard
			</button>
			<button (click)="apply()" [disabled]="true">
				<i class="fa-solid fa-check margin-right-small"></i>
				Apply
			</button>
		</div>
	</div>
</div>
